import { Injectable } from "@angular/core";
import { AitTransporte } from '@tivic-team/manager-ts/dist/mob';
import { Concessao } from "@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity";
import { Fase } from "@tivic-team/manager-ts/dist/ptc/entities/fase.entity";
import { AitTransporteController } from "app/controllers/mob/ait-transporte.controller";
import { AitTransporteImagemDTO } from "app/model/dtos/mob/ait-transporte-imagem.dto";
import { AitTransporteDTO, AitTransporteListDTO } from "app/model/dtos/mob/ait-transporte.dto";
import { RecursoDTO } from "app/model/dtos/mob/recurso.dto";
import { AitTransporteSearch } from 'app/services/mob/ait-transporte.search';
import { ApiService } from "../api-service.interface";
import { LoaderService } from "../loader.service";

@Injectable({
  providedIn: "root",
})
export class AitTransporteService implements ApiService<AitTransporte>{
  constructor(
    private _aitTransporteController: AitTransporteController,
    private _loaderService: LoaderService
  ) { }
  
  get(...args: number[]): Promise<AitTransporte> {
    throw new Error("Method not implemented.");
  }
  create(entity: AitTransporte): Promise<AitTransporte> {
    throw new Error("Method not implemented.");
  }
  update(entity: AitTransporte): Promise<AitTransporte> {
    throw new Error("Method not implemented.");
  }

  async find(aitTransporteSearch?: AitTransporteSearch): Promise<AitTransporte[]> {
    this._loaderService.show();
    return this._aitTransporteController.find(aitTransporteSearch && aitTransporteSearch.getFilters() || null).finally(() => this._loaderService.hide());
}

  async findAitColetivoUrbano(aitTransporteSearch?: AitTransporteSearch): Promise<AitTransporteListDTO> {
    this._loaderService.show();

    try {
      return await this._aitTransporteController.findAitColetivoUrbano(
        (aitTransporteSearch && aitTransporteSearch.getFilters()) || null
      ).finally(() => this._loaderService.hide());
    } catch (error) {
      this._loaderService.hide()
      console.log(error);
      return null;
    }
  }

  getAit(cdAit: number): Promise<AitTransporteDTO> {
    this._loaderService.show();
    return this._aitTransporteController.getAit(cdAit).finally(() => this._loaderService.hide());
  }

  async getFaseByAit(cdAit: number): Promise<Fase> {
    this._loaderService.show();
    return this._aitTransporteController
      .getFaseByAit(cdAit)
      .finally(() => this._loaderService.hide());
  }

  async getAllRecursos(cdAit: number): Promise<RecursoDTO[]> {
    this._loaderService.show();
    return this._aitTransporteController
      .getAllRecursos(cdAit)
      .finally(() => this._loaderService.hide());
  }

  saveAitTransporte(ait: AitTransporteDTO): Promise<AitTransporteDTO> {
    this._loaderService.show();
    if (ait.cdAit) {
      return this._aitTransporteController.updateAitTransporte(ait).finally(() => this._loaderService.hide());
    } else {
      return this._aitTransporteController.createAitTransporte(ait).finally(() => this._loaderService.hide());
    }
  }

  async getConcessaoByPermissionario(cdPessoa: number): Promise<Concessao> {
    this._loaderService.show();
    return this._aitTransporteController.getConcessaoByPermissionario(cdPessoa).finally(() => this._loaderService.hide());
  }

  async getImagens(cdAit: number): Promise<Array<AitTransporteImagemDTO>> {
    this._loaderService.show();
    return this._aitTransporteController.getImagens(cdAit).finally(() => this._loaderService.hide());
  }
}
